import {Outlet} from 'react-router-dom'
import {AuthenticatedTemplate, useMsal, useMsalAuthentication} from '@azure/msal-react'
import './SecuredApp.scss'
import { InteractionType } from '@azure/msal-browser'
import { signinRequest } from '../../authentication/authConfig'
import { setAppInsightUser } from '../../util/tracking/appInsight'
import { useEffect } from 'react'


const SecuredApp = () => {
   
    const {result} = useMsalAuthentication(InteractionType.Redirect, signinRequest)
    const {instance} = useMsal()

    useEffect(() => {
        if(result?.account){
            instance.setActiveAccount(result.account)
            setAppInsightUser(result.account.username)
        }
    }, [result, instance])

    return (
        <AuthenticatedTemplate>
            <div className="authenticated-container" data-testid="secured-app-test-component">
                <Outlet/>
            </div>
        </AuthenticatedTemplate>
    )
}

export default SecuredApp
